import React from 'react';
import { Tabs } from 'antd';
import { useAuth } from "../../hooks/use-auth";

import Statistic from './content/statistic';
import Messages from './content/messages';
import Poems from './content/addPoemForm';
import PoemsList from './content/allPoems';
import Writers from './content/addWriterForm';
import LikedMessages from './content/likedMessages';
import Settings from './content/settingsForm';
import Video from './content/addVideo';
import AllVideo from './content/allVideo';
import AllWriters from './content/allWriters';

import NoAccess from '../errors/403';

function Admin() {
  const { isAuth } = useAuth();

  const items = [
    {
      key: '1',
      label: 'Bütün mesajlar',
      children: <Messages />,
    },
    {
      key: '2',
      label: 'Bəyənilən mesajlar',
      children: <LikedMessages />,
    },
    {
      key: '3',
      label: 'Şeir Əlavə et',
      children: <Poems />,
    },
    {
      key: '4',
      label: ' Bütün şeirlər',
      children: <PoemsList />,
    },
    {
      key: '5',
      label: 'Ṣair və haqqında Əlavə et',
      children: <Writers />,
    },
    {
      key: '6',
      label: 'Ayarlar',
      children: <Settings />,
    },
    {
      key: '7',
      label: 'Add Video',
      children: <Video />,
    },
    {
      key: '8',
      label: 'Edit Videos',
      children: <AllVideo />,
    },
    {
      key: '9',
      label: 'Edit Poets',
      children: <AllWriters />,
    }
  ];

  return isAuth ? (
    <>
    <div className='AdminPage'>

      <div className="mt-6">
        <Statistic />
      </div>
      <h1 className='mt-5'>MESAJLAR</h1>
      <div className="mt-2">
        <Tabs 
        defaultActiveKey="1" 
        items={items} 
        />
      </div>
    </div>
    </>
    ) : (
      <NoAccess />
    );
}

export default Admin;